import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useMetadataTagsListQuery } from "entities/metadataTags/queries/useMetadataTagsListQuery";
import { FC } from "react";
import MetadataTagDetails from "./components/MetadataTagDetails";
import { MetadataTagsPageProvider, useMetadataTagsPage } from "./context";
import { getMetadataColumns } from "./helpers";
import {
  StyledDataGrid,
  StyledEmptyWrapper,
  StyledPaper,
  StyledTypography,
  StyledSpinnerWrapper,
} from "./styled";

const MetadataContainer = () => (
  <MetadataTagsPageProvider>
    <MetadataTags />
  </MetadataTagsPageProvider>
);

const MetadataTags: FC = () => {
  const { metadataTagDetailsDrawer } = useMetadataTagsPage();

  const columnsParams = {
    metadataTagDetailsDrawer,
  };
  const { data, isLoading } = useMetadataTagsListQuery();

  const columns = getMetadataColumns(columnsParams);

  if (!isLoading && !data?.length) {
    return (
      <StyledPaper>
        <StyledEmptyWrapper>
          <StyledTypography>No Results Found</StyledTypography>
        </StyledEmptyWrapper>
      </StyledPaper>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "70vh" }}>
      {!isLoading && data?.length && (
        <>
          <StyledDataGrid
            onRowClick={(params) =>
              metadataTagDetailsDrawer.openDrawer(params.row.id)
            }
            columns={columns}
            rows={data}
            disableColumnMenu
            rowHeight={48}
            loading={isLoading}
            disableRowSelectionOnClick
          />
          <MetadataTagDetails />
        </>
      )}
      {isLoading && (
        <StyledSpinnerWrapper>
          <CircularProgress />
        </StyledSpinnerWrapper>
      )}
    </Box>
  );
};
export default MetadataContainer;
